// aby w innym miescu wykonać ten kod z poprawnym wskazaniem window użyc gisonUrls.call(this)

function getGisonURL() {
     return {
          listaPlanow: `https://listaplanow.gison.pl/${window.PROFILNAME}`,
     };
}

export default getGisonURL;
